/* global axios */

class ProductVariantsAPI {
  get(accountId, productId) {
    return axios.get(`/api/v1/accounts/${accountId}/products/${productId}/variants`);
  }

  create(accountId, productId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/products/${productId}/variants`, {
      product_variant: payload,
    });
  }

  update(accountId, productId, id, payload) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/products/${productId}/variants/${id}`,
      { product_variant: payload }
    );
  }

  delete(accountId, productId, id) {
    return axios.delete(
      `/api/v1/accounts/${accountId}/products/${productId}/variants/${id}`
    );
  }
}

export default new ProductVariantsAPI();
